export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5950.dd990152.jpg";